import Input from './Input';
import FormGroup from './FormGroup';
import { FormFeedback } from 'reactstrap';

function InputGroup({ label, required, error, formGroupStyle, ...rest }) {
  return (
    <FormGroup style={formGroupStyle}>
      <label>
        {label}
        {required && ' *'}
      </label>
      <Input invalid={error} {...rest} />
      {error && <FormFeedback>{error}</FormFeedback>}
    </FormGroup>
  );
}

export default InputGroup;
